import {
  ResetReconciliationStatistics,
  TriggerManualDataAcquisition,
  SkipNextDataAcquisitionInstance,
  GetSFMDisplay,
  DropDataAcquisitionFile,
} from "@helpers/helpers";
import SfmModalStore from "@stores/SfmModalStore";
import { FIRST_INDEX } from "./constants";

export const getActionsConfig = (myStore, translate) => {
  const actions = {
    FILE_DROP: {
      actionTypeTag: "FILE_DROP",
      name: translate("data-acquisitions.actions.FILE_DROP"),
      actionFN: (row) => {
        // This will be handled by the parent component opening the modal
      },
    },
    RUN_NOW: {
      actionTypeTag: "RUN_NOW",
      name: translate("data-acquisitions.actions.RUN_NOW"),
      actionFN: (row) => {
        myStore.setLoading(true);
        TriggerManualDataAcquisition(
          row.original.DataAcquisitionId,
          (data) => {
            const sfmData = GetSFMDisplay(data.SFM);
            SfmModalStore.open(sfmData, () => {
              window.location.href = "/data-acquisitions";
            });
          },
          myStore
        );
      },
      confirmationMessage: translate(
        "data-acquisitions.confirmation-messages.RUN_NOW"
      ),
      confirmation: true,
    },
    SKIP_NEXT_INSTANCE: {
      actionTypeTag: "SKIP_NEXT_INSTANCE",
      name: translate("data-acquisitions.actions.SKIP_NEXT_INSTANCE"),
      actionFN: (row) => {
        myStore.setLoading(true);
        SkipNextDataAcquisitionInstance(
          row.original.DataAcquisitionId,
          (data) => {
            const sfmData = GetSFMDisplay(data.SFM);
            SfmModalStore.open(sfmData, () => {
              window.location.href = "/data-acquisitions";
            });
          },
          myStore
        );
      },
      confirmationMessage: translate(
        "data-acquisitions.confirmation-messages.SKIP_NEXT_INSTANCE"
      ),
      confirmation: true,
    },
    RESET_PERCENTAGE: (row) => {
      return {
        actionTypeTag: "RESET_PERCENTAGE",
        name: translate("data-acquisitions.actions.RESET_PERCENTAGE"),
        actionFN: () => {
          myStore.setLoading(true);
          ResetReconciliationStatistics(
            row.original.Statistics?.[FIRST_INDEX]?.StatisticTag,
            row.original.DataAcquisitionId.toString(),
            (data) => {
              const sfmData = GetSFMDisplay(data.SFM);
              SfmModalStore.open(sfmData, () => {
                window.location.href = "/data-acquisitions";
              });
            },
            myStore
          );
        },
        confirmationMessage: translate(
          "data-acquisitions.confirmation-messages.RESET_PERCENTAGE"
        ),
        confirmation: true,
      };
    },
  };

  return actions;
};

export const createFileDropAction = (setOpenFileDropModal, setCurrentDataAcquisitionId, myStore, translate) => {
  return {
    actionTypeTag: "FILE_DROP",
    name: translate("data-acquisitions.actions.FILE_DROP"),
    actionFN: (row) => {
      setOpenFileDropModal(true);
      setCurrentDataAcquisitionId(row.original.DataAcquisitionId);
      myStore.setLoading(false);
    },
  };
};

export const handleFileDrop = (
  currentDataAcquisitionId,
  droppedFiles,
  myStore
) => {
  myStore.setLoading(true);
  DropDataAcquisitionFile(
    currentDataAcquisitionId,
    droppedFiles,
    (data) => {
      const sfmData = GetSFMDisplay(data.SFM);
      SfmModalStore.open(sfmData, () => {
        window.location.href = "/data-acquisitions";
      });
    },
    myStore
  );
};
